import AppPage from '../../mixins/app-page'

import AppNewsletter from '../app-newsletter'
import AppTeamIndicator from '../app-team-indicator'
import AppTeamSingle from '../app-team-single'

import SimpleGridExperience from '../../libs/experience/SimpleGridExperience'

export default
{
    name: 'page-team',

    mixins: [
        AppPage
    ],

    components: {
        AppNewsletter,
        AppTeamIndicator,
        AppTeamSingle
    },

    data() {
        return {
            // teamsPositionsTop: null,
            teamsHeight: null,
            containerHeight: null,
            teams: this.$root.content.global.teams
        }
    },

    created() {
        this.teamsPositionsTop = []
        this.lineAdvisorsIsActivated = false

        // this.eventHub.$on('app-team-indicator:mounted', this.componentTeamIndicatorMounted)
        this.eventHub.$on('window:resize', this.onResize)
    },

    mounted() {
        this.containerHeight = this.$el.querySelector('.p-team__container__wrapper').offsetHeight

        this.$background = document.querySelector('.js-background')
        this.experience = new SimpleGridExperience()
        this.experience.renderer.domElement.classList.add('p-team__experience')
        this.experience.renderer.domElement.classList.add('u-absolute')
        this.experience.renderer.domElement.classList.add('u-pos-tl')

        this.$background.appendChild(this.experience.renderer.domElement)

        this.teams.forEach((team, index) => {
            this.teamsPositionsTop.push(document.querySelector(`.js-team-container--${index}`).getBoundingClientRect().top + this.$root.currScrollTop)
        })
    },

    destroyed() {
        this.$background.removeChild(this.experience.renderer.domElement)
        this.experience.dispose()
        
        // this.eventHub.$off('app-team-indicator:mounted', this.componentTeamIndicatorMounted)
        this.eventHub.$off('window:resize', this.onResize)
    },

    methods: {
        onResize() {
            this.containerHeight = this.$el.querySelector('.p-team__container__wrapper').offsetHeight
            // this.componentTeamIndicatorMounted()
        },

        onEnterFrame() {
            // if (this.$el.querySelector('.js-left-wrapper') && this.$el.querySelector('.js-right-wrapper')) {
            //     this.$el.querySelectorAll('.js-left-wrapper').forEach(el => {
            //         el.style.transform = `translateY(${-Math.round(this.$root.currScrollTop * this.$root.content.global.teamColumnsVariation)}px) translateZ(0)`
            //     })
            // }

            if (this.teamsPositionsTop && this.teamsPositionsTop[1] <= this.$root.currScrollTop + this.$root.height && !this.lineAdvisorsIsActivated) {
                this.lineAdvisorsIsActivated = true
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/page-team/script.js